import { render } from "./AlternativeActivity.vue?vue&type=template&id=743c177c&scoped=true"
import script from "./AlternativeActivity.vue?vue&type=script&lang=js"
export * from "./AlternativeActivity.vue?vue&type=script&lang=js"

import "./AlternativeActivity.vue?vue&type=style&index=0&id=743c177c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-743c177c"]])

export default __exports__